export type SuccessLocationState = {
  fromOnboardingComplete?: boolean;
};

export const successNavigationOptions = {
  replace: true,
  state: { fromOnboardingComplete: true },
} as const satisfies { replace: boolean; state: SuccessLocationState };

export function hasCompletedOnboarding(state: unknown): boolean {
  if (typeof state !== 'object' || state === null) {
    return false;
  }
  return (state as SuccessLocationState).fromOnboardingComplete === true;
}
